var _circle, _path, _path2, _g, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccsessfullIcon = function SvgSuccsessfullIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 156,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.545,
    cy: 94.707,
    r: 55.94,
    fill: "url(#SuccsessfullIcon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.269 54.392-42.182 82c-3.124 6.073 3.408 12.567 9.463 9.408l81.116-42.324c2.383-1.243 2.886-4.435 1.001-6.35l-42.99-43.71c-1.91-1.942-5.162-1.447-6.408.976Z",
    fill: "url(#SuccsessfullIcon_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "SuccsessfullIcon_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 52,
    width: 94,
    height: 95
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52.22 54.642-42.077 81.462c-3.135 6.068 3.387 12.573 9.447 9.424l80.933-42.056c2.39-1.242 2.894-4.443 1.001-6.36L58.619 53.667c-1.91-1.934-5.152-1.44-6.4.975Z",
    fill: "url(#SuccsessfullIcon_svg__c)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SuccsessfullIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.302 44.594 51.705 48.94l28.288 68.976 10.598-4.346-28.289-68.976Zm-31.571 24.33 10.597-4.346 26.632 64.937-10.597 4.346L30.73 68.924ZM26.528 89.2l-10.597 4.347 23.18 56.519 10.597-4.347L26.528 89.2ZM7.732 99.492l-10.598 4.346 23.18 56.519 10.597-4.347-23.18-56.518Z",
    fill: "url(#SuccsessfullIcon_svg__e)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.777,
    cy: 77.689,
    rx: 34.438,
    ry: 9.109,
    transform: "rotate(46.11 77.777 77.69)",
    fill: "url(#SuccsessfullIcon_svg__f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.195 67.406c3.034-3.301 9.315-12.526 10.171-23.019.857-10.492-1.606-20.966-2.944-24.891M92.876 62.053c3.212-3.658 10.439-13.061 13.65-21.412 3.212-8.351 2.766-19.36 2.142-23.822m-11.51 68.52c4.818-3.747 12.352-9.412 25.695-10.439 17.398-1.338 26.766 6.156 32.119 9.1",
    stroke: "#DEE4FC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F76E63",
    d: "m84.44 50.49 3.695 1.483-1.484 3.695-3.695-1.484z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#526EED",
    d: "m98.866 68.66 4.494-10.318 3.684 1.604-4.493 10.318z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.402 60.9a5.941 5.941 0 0 0-8.116 2.174l5.145 2.97 2.97-5.144ZM98.413 45.75a4.936 4.936 0 0 0-3.49-6.046l-1.278 4.768 4.768 1.277Z",
    fill: "#4E6DF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 17.072a5.027 5.027 0 0 0-6.172 3.526l4.85 1.324 1.323-4.85Z",
    fill: "#D1DFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.58 36.456a4.817 4.817 0 0 0-5.9-3.407l1.247 4.654 4.653-1.247Z",
    fill: "#F7D7D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.36 86.774a5.941 5.941 0 0 0-.368-8.394l-4.013 4.381 4.381 4.013Z",
    fill: "#4E6DF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M124.532 43.995a5.941 5.941 0 0 0-7.277-4.201l1.538 5.739 5.739-1.538Z",
    fill: "#FFA66B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m92.78 36.94-.13-.078a7.151 7.151 0 0 0 .13.079Zm-.18-.11a6.367 6.367 0 0 1 6.55-10.916l-1.952 3.255a2.574 2.574 0 0 0-2.645 4.408L92.6 36.83Z",
    fill: "#8978F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.286 85.455a4.983 4.983 0 0 1-8.049-5.87l2.399 1.749a2.014 2.014 0 0 0 3.25 2.37l2.4 1.751Zm-7.938-6.024-.049.067-.049.067.098-.134Z",
    fill: "#FFA66B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m111.855 52.31.101-.01a4.217 4.217 0 0 0-.101.01Zm.212-.019a7.612 7.612 0 0 1 8.112 6.902 7.612 7.612 0 0 1-6.727 8.257l-.413-4.52a3.077 3.077 0 0 0-.56-6.12l-.412-4.519Z",
    fill: "#F76E63"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m94.014 76.2-.001.108v-.054l.001-.053Zm-.006.26c-.193 5.22-4.528 9.352-9.777 9.268-5.249-.085-9.449-4.353-9.474-9.578l5.739.093a3.893 3.893 0 0 0 7.773.125l5.74.092Z",
    fill: "#5FC6B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#526EED",
    d: "m127.845 63.358 9.337 1.653-.59 3.334-9.337-1.653z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F76E63",
    d: "m107.204 83.198 9.912 4.894-1.748 3.54-9.912-4.894z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BB3FA",
    d: "m126.868 53.382 6.482-6.584 2.351 2.315-6.481 6.584z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.705 65.076a4.853 4.853 0 0 1 3.741-8.954l-1.116 2.67a1.962 1.962 0 0 0-1.51 3.615l-1.115 2.67Zm3.901-8.887-.065-.028a6.095 6.095 0 0 0-.066-.027l.131.055Z",
    fill: "#FFE46B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.359 26.07a5.905 5.905 0 0 1-11.651 1.917l3.473-.572a2.387 2.387 0 0 0 4.704-.773l3.474-.572Zm-11.691 1.675.019.118.02.118-.039-.236Z",
    fill: "#F7A9A3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccsessfullIcon_svg__a",
    x1: 57.545,
    y1: 38.767,
    x2: 57.545,
    y2: 150.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99B0E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccsessfullIcon_svg__b",
    x1: 52.728,
    y1: 49.473,
    x2: 52.728,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccsessfullIcon_svg__c",
    x1: 52.679,
    y1: 49.747,
    x2: 52.679,
    y2: 155.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccsessfullIcon_svg__e",
    x1: 70.457,
    y1: 83.288,
    x2: 5.637,
    y2: 152.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccsessfullIcon_svg__f",
    x1: 77.777,
    y1: 68.58,
    x2: 77.777,
    y2: 86.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BCEC"
  })))));
};
export default SvgSuccsessfullIcon;